export default __webpack_public_path__ + "static/media/howtocreate.7ae18163.mp4";